import { render, staticRenderFns } from "./issue-issued.vue?vue&type=template&id=d1fcc63c&lang=pug&"
import script from "./issue-issued.vue?vue&type=script&lang=ts&"
export * from "./issue-issued.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports